// src/hooks/termOfPayments/useDeleteTermOfPayment.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteTermOfPayment } from "../../api/apiTermOfPayments";
import parseError from "../../utils/parseError";

const useDeleteTermOfPayment = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteTermOfPayments, isPending } = useMutation({
        mutationFn: deleteTermOfPayment,
        onSuccess: (res) => {
            const message = res?.message || "Term of payment deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["termOfPayments"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete term of payment");
        },
    });

    return { deleteTermOfPayments, isPending };
};

export default useDeleteTermOfPayment;